export var ThemeOptions;
(function (ThemeOptions) {
    ThemeOptions["DARK"] = "dark";
    ThemeOptions["LIGHT"] = "light";
})(ThemeOptions || (ThemeOptions = {}));
// The skins of a theme, format is {baseTheme}-{varientName}
export var ThemeSkin;
(function (ThemeSkin) {
    ThemeSkin["GREEN"] = "light-green";
})(ThemeSkin || (ThemeSkin = {}));
export var DeviationViewMode;
(function (DeviationViewMode) {
    DeviationViewMode["Theater"] = "theater";
    DeviationViewMode["Fullscreen"] = "fullscreen";
    DeviationViewMode["Normal"] = "regular";
})(DeviationViewMode || (DeviationViewMode = {}));
//# sourceMappingURL=types.js.map